/**
 * Device orientation hook for landscape vs portrait and desktop detection.
 */
import { useState, useEffect } from "react";

/**
 * Tracks landscape orientation and whether the client is a desktop browser.
 *
 * @returns {{ isDesktop: boolean, isLandscape: boolean }}
 */
export default function useOrientation() {
  const [isLandscape, setIsLandscape] = useState(true);
  /**
   * Updates landscape state when the orientation media query changes.
   *
   * @param {MediaQueryList} mql Orientation media query.
   * @returns {void}
   */
  const handleOrientationChange = (mql) => {
    setIsLandscape(mql.matches);
  };

  // Effect to setup listeners & current orientation
  useEffect(() => {
    const landscapeMediaQuery = window.matchMedia("(orientation: landscape)");
    setIsLandscape(landscapeMediaQuery.matches);
    landscapeMediaQuery.addEventListener("change", handleOrientationChange);

    // Cleanup function
    return () => {
      landscapeMediaQuery.removeEventListener("change", handleOrientationChange);
    };
  }, []);

  return {
    isDesktop: !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    isLandscape,
  };
}
